import './scss/index.scss';
import 'owl.carousel';
import { dcFactory } from 'dc';
import PromotionalSliderComponent from './js/promotional-slider.component';
import ScrollDownComponent from './js/scroll-down.component';

dcFactory.register(PromotionalSliderComponent);
dcFactory.register(ScrollDownComponent);

